import {Dispatch} from "react";
import {IMetaData, ImportedSource, parseTouchVideoFlow} from "../../utility/cookbookImporter";
import {PathwayContext} from "./PathwayContext";
import {StateData} from "../../fstn/state";
import {off, onValue, ref} from "@firebase/database";
import {remove as removeStore, update as updateStore} from "../../redux/slices/firebase";

type States = {[key: string]: StateData};

export class CookbookContext extends PathwayContext {
    private meta: {[key: string]: IMetaData} = {};

    public constructor(dispatch: Dispatch<any>, private user: string) {
        super(dispatch);
    }

    pushState = (project: string, value: unknown) =>
        Promise.resolve(null);

    removeNetwork = (project: string) => Promise.resolve();

    removeState = (project: string, state: string) => Promise.resolve();

    setNetworkMember = (project: string, member: string, value: unknown) => Promise.resolve();

    setStateMember = (project: string, state: string, member: string, value: unknown) => {
        const getTextPath = (member: "script" | "name" | "summary", project: string, meta: IMetaData) => {
            return `nodes/${project}/${meta.parent}/nodes/${meta[member]}/m_editableText0/m_contents`
        };
        const meta = this.meta[state];

        if ((member === "script" || member === "name" || member === "summary") && meta[member] !== undefined) {
            return this.set(getTextPath(member, project, meta), value);
        }
        return Promise.resolve();
    }

    setStatePosition = (project: string, state: string, value: unknown) => {
        const meta = this.meta[state];

        if(meta.parent && meta.index)
        {
            const path = `nodes/${project}/${meta.parent}/nodes/${meta.index}/m_pos`;
            return this.set(path, value);
        }

        return Promise.resolve();
    }

    setStateTransitionMember = (project: string, state: string, transition: number, member: string, value: unknown) =>
        Promise.resolve();

    filterStates = (key: string | undefined, states: States, visited: string[] = [], filtered: States = {}): States => {
        if (key === undefined || visited.includes(key) || ! states[key]) return filtered;
        
        const state = states[key];

        visited.push(key);
        filtered[key] = state;
        state.transitions.forEach(transition => {
            this.filterStates(transition.destination!, states, visited, filtered);
        });
        this.filterStates(state.parent, states, visited, filtered);
        this.filterStates(state.child, states, visited, filtered);
        return filtered;
    }
    // If filter is true then only states that can be reached are added to the network 
    trackNetwork = (network: string, filter = false) => {
        onValue(ref(this.database, `nodes/${network}`), snapshot => {
            const imported = parseTouchVideoFlow(snapshot.val() as ImportedSource);
            const initial = imported.initial[imported.initial.length - 1];

            this.meta = imported.meta;
            this.dispatch(updateStore({
                store: ["network", "initial"],
                update: initial
            }));
            this.dispatch(updateStore({
                store: ["network", "states"],
                update: filter ? this.filterStates(initial, imported.states) : imported.states
            }));
            this.dispatch(updateStore({
                store: ["localizedKeys"],
                update: imported.localized || {}
            }));
        });
        this.track(`constants/${network}`, ["constants"]);
        this.track(`locks/${network}`, ["locks"]);
        this.track(`shortcuts/${network}`, ["shortcuts"]);
        this.track(`tags/${network}`, ["tags"]);
        this.track(`variables/${network}`, ["network", "registers"]);
        this.track(`versions/${network}/import`, ["versions"]);
    }
    untrackNetwork = (network: string) => {
        off(ref(this.database, `nodes/${network}`));
        this.dispatch(removeStore({remove: ["network", "initial"]}));
        this.dispatch(removeStore({remove: ["network", "states"]}));
        this.untrack(`constants/${network}`);
        this.untrack(`locks/${network}`);
        this.untrack(`shortcuts/${network}`);
        this.untrack(`tags/${network}`);
        this.untrack(`variables/${network}`);
        this.untrack(`versions/${network}/import`);
    }
}